import React, {useEffect} from 'react'
import {useSelector} from 'react-redux'
import {FiAlertTriangle} from 'react-icons/fi'
import {AiOutlineCheckCircle} from 'react-icons/ai'
import {vmoToast} from 'vmo-library'
import {get} from 'utils/helper'

const withToast = Component => props => {
  const {apiData, successLabels = [], errorLabels = []} = useSelector(state => state.apiReducer)
  useEffect(() => {
    if (successLabels.includes(get(['label'], apiData)) && get(['showToast'], apiData)) {
      if (apiData.successMessage) {
        vmoToast.success(
          <div className="toast-body">
            <AiOutlineCheckCircle /> <span>{apiData.successMessage}</span>
          </div>
        )
      } else if (apiData.successMessage !== null) {
        vmoToast.info(
          <div className="toast-body">
            <AiOutlineCheckCircle />
            <span>{apiData.successMessage}</span>
          </div>
        )
      }
    }
    if (errorLabels.includes(get(['label'], apiData)) && get(['showToast'], apiData)) {
      vmoToast.error(
        <div className="toast-body">
          <FiAlertTriangle />
          <span>{apiData.errorMessage}</span>
        </div>
      )
    }
  }, [apiData, successLabels, errorLabels])

  return <Component {...props} />
}

export default withToast
